<template>
    <div class="section-upgrade" v-bar="{
        useScrollbarPseudo: true,
        preventParentScroll: true,
        unselectableBody: false
    }">
        <div class="section-upgrade__box">
            <div class="section-upgrade__content">
                <div class="section-upgrade__close" @click="onClose">
                    <img src="@/assets/icons/cross.svg" />
                </div>
                <div>
                    <div class="section-upgrade__title">{{ good.title }}</div>
                    <div class="section-upgrade__region">Регион: {{ region.title }}({{ region.progress }}%)</div>
                    <div class="section-upgrade__description">{{ good.description }}</div>
                </div>
                <div class="section-upgrade__upgrades">
                    <div class="section-upgrade__subtitle">Улучшения:</div>
                    <div class="section-upgrade__list">
                        <div v-for="(upgrade, index) in upgrades" :key="index" class="section-upgrade__list-box" :class="`section-upgrade__list-box--id-${index + 1}`">
                            <block-upgrade
                                :id="upgrade.id"
                                :disabled="!isGuide && (balance < upgrade.price || region.levelIndex < index)"
                                :upgraded="index + 1 <= region.levelIndex"
                                :price="upgrade.price"
                                @click="onShowUpgrade($event, upgrade)"
                            />
                        </div>
                    </div>
                </div>

                <ui-tooltip ref="tooltip">
                    <div v-if="selectUpgrade" class="section-upgrade-tooltip">
                        <div class="section-upgrade-tooltip__title">{{ selectUpgrade.title }}</div>
                        <div class="section-upgrade-tooltip__price">
                            Стоимость: {{ selectUpgrade.price }} {{
                                selectUpgrade.price |
                                    numerate('балл:::баллa:::баллов') }}
                        </div>
                        <div class="section-upgrade-tooltip__description">{{ selectUpgrade.description }}</div>
                        <div class="section-upgrade-tooltip__btns">
                            <button class="section-upgrade-tooltip__btn ui-btn" @click="onUpgrade">Улучшить объявление</button>
                            <a class="section-upgrade-tooltip__btn section-upgrade-tooltip__btn-prompt ui-btn" @click="onShowAdvise">
                                <icon-warning class="section-upgrade-tooltip__btn-prompt-icon" />
                                Совет
                            </a>
                        </div>
                    </div>
                </ui-tooltip>

                <ui-popup ref="popup" @close="onCloseAdvice">
                    <div v-if="selectUpgrade" class="section-upgrade-popup">
                        <div class="section-upgrade-popup__text">{{ selectUpgrade.advice }}</div>
                        <div class="section-upgrade-popup__btn-box">
                            <button class="ui-btn section-upgrade-popup__btn" @click="$refs.popup.close()">
                                Спасибо!
                            </button>
                        </div>
                    </div>
                </ui-popup>

                <block-good-img class="section-upgrade__img" :id="good.id" :class="`section-upgrade__img--id-${good.id}`" />
            </div>
        </div>
    </div>
</template>

<script>
    import upgrades from '@/store/_upgrades.json'
    import {mapState, mapGetters, mapActions} from 'vuex'

    export default {
        props: {
            regionId: {
                type: Number,
                required: true
            }
        },
        data () {
            return {
                selectUpgrade: null,
                upgrades: upgrades.slice(1)
            }
        },
        computed: {
            ...mapState('balance', ['balance']),
            ...mapGetters('goods', ['goodById']),
            ...mapGetters('regions', ['regionById']),
            ...mapState('guide', ['step']),

            region () {
                return this.regionById(this.regionId)
            },

            good () {
                return this.goodById(this.region.goodId)
            },

            isGuide () {
                return this.step && this.step.name === 'upgrades'
            }
        },
        methods: {
            ...mapActions('regions', ['upgradeRegion']),
            ...mapActions('control', ['pause', 'start']),

            onClose () {
                this.$emit('close')
            },

            onCloseAdvice () {
                if (window.innerWidth > 770) {
                    this.start()
                }
            },

            onUpgrade () {
                this.upgradeRegion(this.region.id)
                this.$refs.tooltip.close()
            },

            onShowAdvise () {
                this.$refs.tooltip.close()
                this.$refs.popup.open()
                this.pause()
            },

            onShowUpgrade (refElement, upgrade) {
                this.$refs.tooltip.open(refElement)
                this.selectUpgrade = upgrade
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .section-upgrade {
        width 100%
        height 100%

        &__content {
            overflow hidden
            background-color #3665F3
            width 100%
            height 100%
            min-height 52.3rem
            position relative
            color #fff
            padding 2rem 3rem
            +layout-xs() {
                padding 2.3rem 2rem 0 2rem
            }
        }

        &__box {
            padding-bottom 0
        }

        &__close {
            background-color #121258
            width 3.8rem
            height @width
            position absolute
            top 0
            right 0
            display flex
            align-items center
            justify-content center
            cursor pointer
            +layout-sm() {
                z-index 6
            }
        }

        &__title {
            padding-right 1rem
            font-size 2rem
            margin-bottom 0.3rem
            font-weight $font-bold
            line-height 2.3rem
            +layout-xs() {
                margin-bottom 1.2rem
            }
        }

        &__region {
            margin-bottom 1.8rem
            font-size 1.5rem
            line-height 1.8rem
            +layout-sm() {
                display: none
            }
        }

        &__description {
            margin-bottom 1.5rem
            font-size 1.5rem
            line-height 1.7rem
            +layout-sm() {
                margin-top 0.6rem
            }
        }

        &__subtitle {
            font-size 1.5rem
            line-height 1.7rem
            font-weight $font-bold
            +layout-sm() {
                margin-top 3.3rem
                font-size 2rem
                line-height 1
            }
        }

        &__upgrades {
            +layout-sm() {
                position relative
                z-index 7
            }
        }

        &__list {
            margin-top 1.9rem
            display grid
            grid-template-columns 1fr 1fr 1fr 1fr
            grid-gap 1.5rem
            +layout-sm() {
                grid-template-columns repeat(4, 7rem)
                grid-gap 1.5rem 2.7rem
            }
            +layout-xs() {
                margin-top 1.2rem
                grid-template-columns repeat(3, 7rem)
            }

            &-box {
                &--id-3 {
                    >>> svg {
                        width 4rem
                        height @width
                    }
                }

                &--id-5 {
                    >>> svg {
                        width 3rem
                        height @width
                    }
                }

                &--id-6 {
                    grid-column 2 / -1
                    +layout-sm() {
                        grid-column auto
                    }
                }
                &--id-7 {
                    >>> svg {
                        width 5.4rem
                        height 5.4rem
                    }
                }
            }
        }

        &__img {
            position absolute
            bottom 0
            +layout-sm() {
                z-index 6
            }

            &--id-1 {
                right 0
                width 16.6rem
                +layout-xs() {
                    width 13.6rem
                    bottom -1.1rem
                    right -3.4rem
                }
            }

            &--id-2 {
                right 0
                width 18.3rem
                +layout-xs() {
                    width 13.3rem
                    right -2rem
                }
            }

            &--id-3 {
                right 3.9rem
                width 8.3rem
                +layout-xs() {
                    right 0.9rem
                    width 7.3rem
                }
            }

            &--id-4 {
                right 1.5rem
                width 16.4rem
                +layout-xs() {
                    width 13.4rem
                    right -1.5rem
                }
            }

            &--id-5 {
                bottom 3.4rem
                right 1.9rem
                width 12.8rem
                +layout-sm() {
                    right: 0
                    bottom: 0
                }
                +layout-xs() {
                    bottom -0.6rem
                    right -1.1rem
                    width 12.8rem
                }
            }

            &--id-6 {
                width 17rem
                right -1rem
                +layout-xs() {
                    right -5rem
                    width 15rem
                }
            }

            &--id-7 {
                width 15rem
                right 1rem
                +layout-xs() {
                    width 13rem
                    bottom -1.1rem
                    right -2rem
                }
            }
        }
    }

    .section-upgrade-popup {
        width 34rem
        +layout-xs() {
            width 28rem
        }
        +layout-xxs() {
            width 23.4rem
            padding-top 1rem
        }

        &__text {
            font-size 1.5rem
            line-height 2.1rem
            +layout-xs() {
                line-height 2.4rem
                padding-right 2rem
            }
        }

        &__btn-box {
            margin-top 2.2rem
        }

        &__btn {
            background-color #121258
            color $color-accent
            width 20.3rem
            +layout-xs() {
                width 100%
            }

            &:hover {
                background-color #629cff
            }

        }
    }

    .section-upgrade-tooltip {
        width 32rem
        +layout-sm() {
            width 100%
            max-width 100%
            margin 0 auto
        }

        &__title {
            font-size 2rem
            line-height 2.5rem
            width 60%
            color $color-light
            +layout-sm() {
                width 100%
            }
        }

        &__price {
            font-size 1.5rem
            line-height 1.8rem
            margin-top: 0.5rem
        }

        &__description {
            margin-top 1.8rem
            font-size 1.5rem
            line-height 1.9rem
        }

        &__btns {
            margin-top 1.3rem
            display flex
            justify-content space-between
            +layout-xxs() {
                flex-direction column
            }
        }

        &__btn {
            flex-basis 50%
            font-size 1.5rem

            &-prompt {
                color $color-light
                background-color #382AEF

                &-icon {
                    margin-right 0.6rem
                    display block
                    width 1.8rem
                    height 1.8rem
                }

                &:hover {
                    background-color #629cff
                }
            }

            & + & {
                margin-left 1rem
                +layout-xxs() {
                    margin-left 0
                    margin-top 1rem
                }

            }
        }
    }
</style>
